import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Service Center: A specialized unit within an institution that provides a particular service to multiple organizational units. (e.g., vivariums, print centers, etc.)',
    name: 'Service Centers',
    partialId: PartialId.Standard.create('svc_centers'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
